import { useState, useEffect } from "react";
import { Card, Tabs, Tab, Box } from "@mui/material";

import LinkIcon from "@mui/icons-material/Link";
import GamepadIcon from "@mui/icons-material/Gamepad";
import GroupIcon from "@mui/icons-material/Group";
import AssignmentIcon from "@mui/icons-material/Assignment";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import CloudIcon from "@mui/icons-material/Cloud";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";

import OrganizationActionsTab from "./tabs/actions";
import OrganizationPersonsTab from "./tabs/persons";
import OrganizationFiscalTab from "./tabs/fiscal";
import OrganizationContabilTab from "./tabs/contabil";
import OrganizationDpTab from "./tabs/dp";
import OrganizationCloudTab from "./tabs/cloud";

import { useOrganization } from ".";

export function TabPanel(props: any) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
    </div>
  );
}

const TabsCard = () => {
  const [value, setValue] = useState(0);
  const organization = useOrganization();

  const handleChange = (event: any, newValue: any) => {
    setValue(newValue);
  };

  useEffect(() => {
    setValue(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [organization.data._id]);

  return (
    <Card>
      <Box
        sx={{
          borderRadius: 1,
          borderBottom: 1,
          borderColor: "divider",
        }}
      >
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <Tab
            label="Ações"
            icon={<GamepadIcon />}
            iconPosition="start"
            sx={{ minHeight: 50 }}
          />
          <Tab
            label="Contatos"
            icon={<GroupIcon />}
            iconPosition="start"
            sx={{ minHeight: 50 }}
          />
          <Tab
            label="Arquivos"
            icon={<CloudIcon />}
            iconPosition="start"
            sx={{ minHeight: 50 }}
          />
          <Tab
            label="Fiscal"
            icon={<ReceiptLongIcon />}
            iconPosition="start"
            sx={{ minHeight: 50 }}
          />
          <Tab
            label="Contábil"
            icon={<MonetizationOnIcon />}
            iconPosition="start"
            sx={{ minHeight: 50 }}
          />
          <Tab
            label="DP"
            icon={<AssignmentIndIcon />}
            iconPosition="start"
            sx={{ minHeight: 50 }}
          />
          {/* <Tab
            label="Tarefas"
            icon={<AssignmentIcon />}
            iconPosition="start"
            sx={{ minHeight: 50 }}
          />
          <Tab
            label="Integrações"
            icon={<LinkIcon />}
            iconPosition="start"
            sx={{ minHeight: 50 }}
          /> */}
        </Tabs>
      </Box>
      <TabPanel value={value} index={0} sx={{ p: 0 }}>
        <OrganizationActionsTab />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <OrganizationPersonsTab />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <OrganizationCloudTab />
      </TabPanel>
      <TabPanel value={value} index={3}>
        <OrganizationFiscalTab />
      </TabPanel>
      <TabPanel value={value} index={4}>
        <OrganizationContabilTab />
      </TabPanel>
      <TabPanel value={value} index={5}>
        <OrganizationDpTab />
      </TabPanel>
      {/* <TabPanel value={value} index={2}></TabPanel>
      <TabPanel value={value} index={3}></TabPanel> */}
    </Card>
  );
};

export default TabsCard;
